module.exports = __webpack_public_path__ + "static/media/infinity-cosmetics.1f6fd25e.jpg";